interface WordmarkProps {
  size?: number;
  dim?: boolean;
}

export function Wordmark({ size = 18, dim = false }: WordmarkProps) {
  return (
    <span
      className="lex-mark t-mono"
      style={{
        fontSize: size,
        letterSpacing: "0.06em",
        fontWeight: 500,
        color: dim ? "var(--text-dim)" : "var(--text)",
        display: "inline-flex",
        alignItems: "baseline",
        gap: 6,
      }}
    >
      <span
        style={{
          fontFamily: "var(--font-display)",
          fontStyle: "italic",
          letterSpacing: "-0.01em",
          fontSize: size * 1.15,
          fontWeight: 400,
        }}
      >
        Lex
      </span>
      <span style={{ opacity: 0.55 }}>·</span>
      <span>30</span>
    </span>
  );
}
